import React, { useState,  useEffect } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from '../layouts/TagInputs';

import { get, post, put } from '../../utility/fetch';
import axios from 'axios';
import notification from '../../utility/notification';
import { usePatient } from '../../contexts';
import { calculateAge} from '../../utility/general'
 
import SpeechToTextButton from "../UI/SpeechToTextButton";
import SuccessModal from './SuccessModal';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from '@mui/material';
import QueueLabWorkModal from './QueueLabWorkModal';
import Spinner from '../UI/Spinner';


let outstandingBalance;

function PayWalkInModal({ closeModal, patientData, referralInfo }) {

    const [payload, setPayload] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLabWorkModalOpen, setIsLabWorkModalOpen] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [activeId, setActiveId] = useState(0);

    // const [outstandingBalance, setOutstandingBalance] = useState(0);
    const [labServices, setlabServices] = useState([]);
    const [paymentSources, setPaymentSources] = useState([]);
    const [checked, setChecked] = useState(false);
    const [internalPayload, setInternalPayload] = useState(
        {
            labServices: [
                {
                    testRequestId: 0,
                    internalLabServiceId: 0
                }
            ]
        }
    );
    const navigate = useNavigate()

    const isMobile = window.innerWidth < 768;

   
    const openModal = () => {
        setIsModalOpen(true);
    };

    console.log(referralInfo)
    console.log(patientData)

    const close = () => {
        setIsModalOpen(false);

        setIsLabWorkModalOpen(true);
        // navigate('/queue-lab-work')

    };


    const closeLabWorkModal = () => {
        setIsLabWorkModalOpen(false);
    }

    const services = [
        { label: 'MRI Scan', value: 1, amount: 20000 },
        { label: 'Ultrasound', value: 2, amount: 15000 },
        { label: 'HIV/AIDS Test', value: 3, amount: 5000 },
        { label: 'Radiology', value: 4, amount: 250000 },
        { label: 'Widal', value: 5, amount: 2000 },
        { label: 'Malaria Test', value: 6, amount: 2000 },
    ];

    const paymentOptions = [
        { label: 'Card', value: 1 },
        { label: 'Transfer', value: 2 },
        { label: 'Cash', value: 3 },
        { label: 'HMO', value: 4 },
    ];

    const getLabServices = async () => {
        let res = await get(`/internallabservice/list/1/1000`);
        setlabServices(res?.data?.recordList.map((service) => (
            {
                label: service?.name,
                value: service?.id,
                amount: service?.cost,
            }
        )))
        console.log(res);
    }

    const getPaymentSources = async () => {
        let res = await get(`/healthcareprovider/getpaymentsources/1/100`);
        console.log(res);
        setPaymentSources(res?.map((source) => ({
            label: source?.paymentChannel,
            value: source?.id
        })))
    }

    const payInternalLabRequest = async () => {
        console.log(selectedServices)
        try {
            let res = await put(`/referredpatient/${referralInfo?.id}/patient/${referralInfo?.patient?.id}/pay-cash-for-internal-lab-service`,
                {
                    payableBy: checked ? 'HMO' : 'Patient',
                    labServices: [
                        {
                            testRequestId: activeId,
                            amount: selectedServices?.cost
                        }
                    ]

                }
            );
            if (res.statusCode === 200) {
                console.log(res)
                notification({ message: res?.data?.message, type: "success" });
                setLoading(false);
                navigate('/procedures')
                openModal();
                // setIsModalOpen(true);
            }
            console.log(res);
        } catch (error) {
            console.error('Error submitting internal lab request:', error);
            setLoading(false);
        }
    }


    const getWalkInDetails = async (id) => {
        try {
            let res = await get(`/walkinlabrequest/${id}`);
            console.log(res);
            setPayload(res?.data);
        } catch (error) {
            console.error('Error fetching walk-in details:', error);
        }
    }


    console.log(selectedServices)


    const submitInternalLabRequest = async () => {
        if(activeId === 0){
            notification({ message: 'Please select a test', type: "error" });
            return;
        }
        setLoading(true);
        console.log(selectedServices)
        try {
            let res = await put(`/referredpatient/${referralInfo?.id}/patient/${referralInfo?.patient?.id}/add-internal-lab-service`,
                {
                    labServices: [
                        {
                            testRequestId: activeId,
                            internalLabServiceId: selectedServices?.internalLabServiceId
                        }
                    ]
                }
            );
            if (res.statusCode === 200) {
                payInternalLabRequest();

            }
            console.log(res);
        } catch (error) {
            console.error('Error submitting internal lab request:', error);
            setLoading(false);
        }
    }

    const handleCheckChange = (check) => {
        setChecked(check.target.checked);
    }


    const handleActive = (active) => {
        setActiveId(active);  
    }



    useEffect(() => {
        getLabServices();
        getPaymentSources();

        if(patientData){
            getWalkInDetails(patientData?.id)
        }
    }, []);

    const handleServiceChange = (selectedOptions) => {


        console.log(selectedOptions);

        let record = referralInfo?.testRequests?.find((item) => item?.generalLabService?.name?.toLowerCase() === selectedOptions?.label?.toLowerCase());
        console.log(record)

        !record ? setSelectedServices({
            id: 0,
            internalLabServiceId: 0,
            cost: 0,
            testRequestId: 0
        }) : setSelectedServices({...record,
            cost: selectedOptions?.amount,
            internalLabServiceId: selectedOptions?.value


        });




        // const total = selectedOptions.reduce((sum, service) => sum + services.find(s => s.value === service.value).amount, 0);
        // setTotalAmount(total);
        // const outstanding = total - referralInfo.hmoCover;
        // setOutstandingBalance(outstanding > 0 ? outstanding : 0);

      //  setSelectedServices(selectedOptions);
       // const total = selectedOptions.reduce((sum, service) => sum + services.find(s => s.value === service?.value).amount, 0);
      //  setTotalAmount(total);
       // const outstanding = total - 10000;
      //  setOutstandingBalance(outstanding > 0 ? outstanding : 0);

    };

    const handleChange = (field, event) => {
        const value = event;
        const name = field;

        setPayload(prevPayload => ({ ...prevPayload, [name]: value?.target ? value.target.value : value }));
    };

    const handleTranscript = (transcript) => {
        setPayload(prevPayload => ({ ...prevPayload, referralNotes: prevPayload.referralNotes ? prevPayload.referralNotes + ' ' + transcript : transcript }));
    };

    return (
        <div className='overlay'>
            <RiCloseFill className='close-btn pointer' onClick={closeModal} />
            <div className="modal-content" style={isMobile ? { width: '95%' } : {}}>
                <div className="flex">
                    <div className="flex space-between flex-v-center m-t-20 ">
                        <h2 className='m-l-20'>Lab Work Order Placement for {`${referralInfo?.patient?.firstName || patientData?.firstName} ${referralInfo?.patient?.lastName || patientData?.lastName}`}</h2>
                    </div>
                </div>
                <div className="tabs m-t-10 bold-text"></div>

                <div>
                    <div className="flex m-t-20">
                        <label className="m-r-10">AGE:</label>
                        <div>{calculateAge(referralInfo?.patient?.dateOfBirth || new Date().toLocaleDateString()) || 0}</div>
                    </div>
                    <div className="flex m-t-20">
                        <label className="m-r-10">Weight:</label>
                        <div>{`${referralInfo?.patient?.weight || 0} KG`}</div>
                    </div>
                </div>

                <div className='flex'>
                    {
                        referralInfo?.testRequests
                        ?.filter((test)=>(test?.isPaid === false))
                        ?.map((test, index)=>(
                            <div key={test?.id} onClick={() => handleActive(test?.id)} className={`flex m-t-20 ${activeId === test?.id ? 'active-key' : 'inactive-key'}`}>
                                <div className="m-r-10">{test?.generalLabService?.name}</div> 
                            </div>
                        ))
                    }
                </div>

                <div className="p-10">

                    <TagInputs label="Select Lab Service" onChange={handleServiceChange} options={labServices} name="referredClinicId" type='R-select' />
                    <TagInputs label="Amount" value={selectedServices?.cost} readOnly />
                    {/* <TagInputs label="HMO Cover" value={referralInfo?.hmoCover || 0} readOnly name="hmoCover" /> */}
                    {/* <TagInputs label="Outstanding Bal" value={(selectedServices?.cost || 0) - (referralInfo?.hmoCover || 0)} readOnly name="outstandingBal" /> */}
                    <TagInputs label="Payment Option" onChange={(value) => handleChange("paymentOption", value)} options={paymentSources} name="paymentOption" type='R-select' />
                    {/* <Checkbox id='hmoCovered' name='hmoCovered' onChange={(value) => handleCheckChange(value)} /> */}
                    {/* <label for="hmoCovered" >HMO Covered ?</label> */}

                    {/* <TagInputs label="Additional Notes" name="referralNotes" value={payload?.referralNotes} onChange={(value) => handleChange("referralNotes", value)} type='textArea' /> */}

              
                    {/* <SpeechToTextButton onTranscript={handleTranscript} /> */}
                    <button disabled={loading} onClick={submitInternalLabRequest} className="submit-btn m-t-20 w-100">{loading ? <span className='flex flex-h-center flex-v-center'>Place order &nbsp; &nbsp; <Spinner width={30} height={30} /></span> : 'Place Order'}</button>
                </div>
            </div>
            {isModalOpen &&

                <SuccessModal Name={`${referralInfo?.patient?.firstName} ${referralInfo?.patient?.lastName}`} payAmount={!checked ? outstandingBalance = selectedServices?.cost : outstandingBalance = 0} closeModal={close} />
            }

            {isLabWorkModalOpen &&
                <QueueLabWorkModal details={referralInfo} labRequest={selectedServices} closeModal={closeLabWorkModal} />

                // <SuccessModal Name={`${referralInfo?.patient?.firstName} ${referralInfo?.patient?.lastName}`} payAmount={outstandingBalance} closeModal={close} />

            }
        </div>
    );
}

export default PayWalkInModal;
